import { useForm } from 'react-hook-form';
import Button from '../Reusable/Button';
import NumberField from '../Reusable/Form/NumberField';
import TextField from '../Reusable/Form/TextInput';
import usePostHook from '../../customHooks/usePostHook';
import APIS from '../../constant/EndPoint';
import usePatchHook from '../../customHooks/usePatchHook';

const CreateUpdateKMRecord = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors
  } = useForm<any>({
    defaultValues: async () => {
      return {
        ...selectedRider
      }
    }
  });
  const { selectedRider, setOpenEditKMRecordPopup, selectedDate } = props

  console.log(errors)

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["km-record"],
    navigateURL: "",
  });

  const { mutateAsync: updateMutateAsync, isLoading } = usePatchHook({
    queryKey: ["km-record"],
    navigateURL: "",
  });

  const handleCreateUpdate = async (values: any, setError: any) => {
    let res;
    const url = selectedRider?.id ? `${APIS.KM_RECORD}${selectedRider?.id}/` : `${APIS.KM_RECORD}`;
    let formData = {
      ...values,
      valid_for_date: selectedDate
    };
    try {
      if (selectedRider?.id) {
        res = await updateMutateAsync({ url, formData, setError })
      } else {
        res = await mutateAsync({ url, formData, setError });
      }
      if (res?.status === 201 || res?.status === 200) {
        setOpenEditKMRecordPopup(false)
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <form onSubmit={handleSubmit((data: any) => handleCreateUpdate(data, setError))} autoComplete="off">
      <NumberField
        setValue={setValue}
        value={getValues().s_km}
        clearErrors={clearErrors}
        label={"Start KM"}
        register={register("s_km", { required: "Start KM is required" })}
        errors={errors?.s_km}
      />
      <TextField
        label={"Start Location"}
        register={register("s_location", { required: "Start Location is required" })}
        errors={errors?.s_location}
      />
      <TextField
        label={"Start Remarks"}
        register={register("s_remarks")}
        errors={errors?.s_remarks}
      />
      <NumberField
        setValue={setValue}
        value={getValues().e_km}
        clearErrors={clearErrors}
        label={"End KM"}
        register={register("e_km", { required: selectedRider?.id ? "End KM is required" : false })}
        errors={errors?.e_km}
      />
      <TextField
        label={"End Location"}
        register={register("e_location", { required: selectedRider?.id ? "End Location is required" : false })}
        errors={errors?.e_location}
      />
      <TextField
        label={"End Remarks"}
        register={register("e_remarks")}
        errors={errors?.e_remarks}
      />
      <div className="flex justify-end w-full">
        <div className="w-[150px] mr-4">
          <Button label={"Create/Update"} isLoading={isPostLoading || isLoading} />
        </div>
      </div>
    </form>
  )
}

export default CreateUpdateKMRecord
